import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'

localStorage.setItem('loggeduser', 'false')

Vue.config.productionTip = false

const config = {
  apiKey: "AIzaSyANAppsE-VpOEAPQT4pFgiDRBFXRrL7qo8",
    authDomain: "udbav-events.firebaseapp.com",
    databaseURL: "https://udbav-events.firebaseio.com",
    projectId: "udbav-events",
    storageBucket: "udbav-events.appspot.com",
    messagingSenderId: "800109946789",
    appId: "1:800109946789:web:c15a363e11dbbbf7506a4c"
}

firebase.initializeApp(config)

export const db = firebase.firestore()
export const auth = firebase.auth()

Vue.config.productionTip = false





new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
